import React, { Suspense } from 'react'
import { Loading, TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import {
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { useContractNotificationCategories } from '../hooks/useContractNotificationCategories'

import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { ResidentNotifications } from 'components'

type ContractChangesViewProps = {
  title: string
  banner: React.ReactNode
  sidebarInfo: React.ReactNode
  children: React.ReactNode
}

export const ContractChangesView: React.FC<ContractChangesViewProps> = ({
  title,
  banner,
  sidebarInfo,
  children,
}) => {
  const { t } = useTranslation(['common'])
  const { frontPagePath } = useContractPaths()
  const { contractNotificationCategories } = useContractNotificationCategories()

  return (
    <TitleController title={title}>
      <ResidentAppView
        title={title}
        backLink={
          <ResidentAppBackLink href={frontPagePath}>
            {t('common:views.home')}
          </ResidentAppBackLink>
        }
        aside={
          <>
            <ResidentNotifications
              categories={contractNotificationCategories}
            />
            {sidebarInfo}
          </>
        }
      >
        <ResidentAppCard>
          {banner}

          <Suspense fallback={<Loading variant="details" />}>
            {children}
          </Suspense>
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
